var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreview({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "9px",
    viewBox: "0 0 15 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Preview") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "All-Icons",
    transform: "translate(-34.000000, -12.000000)",
    fill: "#B7844D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1210355,18.5771953 C45.5408256,17.9774849 45.7787067,17.2619214 45.7787067,16.4850239 C45.7787067,15.7013115 45.5338291,14.9789331 45.114039,14.3792227 C46.3524198,15.013689 47.150021,15.919388 47.5628147,16.4850239 C47.150021,17.0506598 46.3524198,17.9502253 45.1210355,18.5771953 M36.3194363,16.4850239 C36.7322299,15.919388 37.5298311,15.013689 38.7752085,14.3792227 C38.3484218,14.9789331 38.1035443,15.7013115 38.1035443,16.4850239 C38.1035443,17.2687363 38.3484218,17.9911147 38.7752085,18.5915065 C37.5298311,17.9570402 36.7322299,17.0506598 36.3194363,16.4850239 M39.3279321,15.3673818 C39.5168376,15.6808668 39.8736592,15.8928099 40.2724598,15.8928099 C40.8811555,15.8928099 41.3779071,15.4082712 41.3779071,14.8153757 C41.3779071,14.4337418 41.1750086,14.0998122 40.8671625,13.9089953 C41.1959981,13.7795123 41.5598162,13.7045485 41.9376272,13.7045485 C43.5188366,13.7045485 44.7991965,14.9516735 44.7991965,16.4850239 C44.7991965,18.0183742 43.5188366,19.2654992 41.9376272,19.2654992 C40.3634144,19.2654992 39.0830545,18.0183742 39.0830545,16.4850239 C39.0830545,16.0897602 39.1670126,15.7081264 39.3279321,15.3673818 M41.9446237,12.4853646 L41.9376272,12.4853646 C37.040076,12.4853646 34.9411255,16.4850239 34.9411255,16.4850239 C34.9411255,16.4850239 37.040076,20.4853646 41.9376272,20.4853646 L41.9446237,20.4853646 C46.8351785,20.4853646 48.9411255,16.4850239 48.9411255,16.4850239 C48.9411255,16.4850239 46.8351785,12.4853646 41.9446237,12.4853646",
    id: "Icon/Preview"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/Preview.23770e8f113f17f8fa20fa68d392080d.svg";
export { ForwardRef as ReactComponent };